import { Card } from '@chakra-ui/react';
import { useCompanyId } from '@packages/core/company/focused-company-context.ts';
import { useTranslate } from '@tolgee/react';
import { useSearchParams } from 'react-router-dom';
import { convertStringToMenuSource } from '../util/convert-string-to-menu-source';
import MenuTable from './component/menu-table';
import { useGetMenus } from './logic/use-get-menus';

export interface PrintRuleMenu {
  id: string;
  title: string;
}

export default function PrintRuleMenuList() {
  const { t } = useTranslate();
  const companyId = useCompanyId();

  const [searchParams] = useSearchParams();
  const service = convertStringToMenuSource(searchParams.get('service') ?? '');

  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const { data, error, loading } = useGetMenus(companyId, service!);

  return (
    <Card.Root rounded={'md'}>
      <Card.Header px={4} py={5}>
        <Card.Title fontSize={'3xl'} fontWeight={600}>
          {t('print-rule.menu-header', 'Choose menu')}
        </Card.Title>
      </Card.Header>
      <Card.Body p={0}>
        <MenuTable menus={data?.menus} loading={loading} error={error} />
      </Card.Body>
    </Card.Root>
  );
}
